import { Player } from '@lottiefiles/react-lottie-player';
import { makeStyles } from '@mui/styles';
import loader from '../../Assets/loading.json';
import { Theme } from '@mui/material';
const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    background: '#302e50',
    zIndex: 99999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  playerStyles: {
    height: '300px',
    width: '300px',
  },
}));

export default function KenLoader() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Player autoplay loop src={loader} speed={2} className={classes.playerStyles}></Player>
    </div>
  );
}
